/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelMap64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelMap64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35 28C35 29.6569 33.6569 31 32 31C30.3431 31 29 29.6569 29 28C29 26.3431 30.3431 25 32 25C33.6569 25 35 26.3431 35 28ZM34 28C34 29.1046 33.1046 30 32 30C30.8954 30 30 29.1046 30 28C30 26.8954 30.8954 26 32 26C33.1046 26 34 26.8954 34 28Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23 28.3334C23 30.0251 23.4494 31.7045 24.2861 33.1442L31.1263 45.4306C31.5075 46.1154 32.4925 46.1154 32.8738 45.4306L39.7152 33.1419C40.551 31.7028 41 30.0242 41 28.3334C41 23.1787 36.9706 19 32 19C27.0294 19 23 23.1787 23 28.3334ZM32 44.9442L25.1553 32.6497L25.1507 32.6417C24.4041 31.3569 24 29.8513 24 28.3334C24 23.6964 27.6157 20 32 20C36.3843 20 40 23.6964 40 28.3334C40 29.8505 39.5963 31.3554 38.8505 32.6397L38.8459 32.6475L32 44.9442Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelMap64Icon.tags = ['map', 'location', 'pin', 'place', 'marker'];

AddPanelMap64Icon.category = '64x64 (Add panel)';

AddPanelMap64Icon.iconSize = 64;
